var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "modal-box",
        {
          attrs: {
            "is-visible": _vm.isVisible,
            title: _vm.Resources.ProjectHome.ChangeDisplayCurrencyTitle,
            icon: "sync",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "gfu-link gfu-link--accent",
                        attrs: { href: "#", "data-qa": "modal-button:cancel" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onCancel.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.Resources.Common.ModalCancelButton))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide _ml-3",
                        attrs: {
                          type: "button",
                          "data-qa": "modal-button:Continue",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onAccept.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.Resources.Common.ModalContinueButton) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            1683864962
          ),
        },
        [
          _c(
            "p",
            [
              _c(
                "localize",
                {
                  attrs: {
                    resource:
                      _vm.Resources.ProjectHome.ChangeDisplayCurrencyParagraph,
                  },
                },
                [
                  _c("strong", { attrs: { "format-key": "0" } }, [
                    _vm._v(_vm._s(_vm.currency.symbol)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.Resources.ProjectHome.ChangeDisplayCurrencyNote) +
                "\n    "
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }